import './vendor';
import feedBlog from './sliders/feed_swiper';
import {initJournal} from './common/journal';
import partnersSwiper from './sliders/partners_swiper';
import clientsSwiper from './sliders/clients_swiper';
import certificateSwiper from './sliders/certificate-swiper';
import footerSwiper from './sliders/footer_swiper';
import decisionsSwiper from './sliders/decisions_swiper';
import gallerySwiper from './sliders/gallery_swiper';
import {initMagazine} from './common/magazine';
import {initImgSwipe} from './sliders/img_swiper';
import {initMasterClass} from './common/master-class';
import {initSubscribe} from './common/subscribe';
import {initScrollTo} from './common/scroll-to';
import {initSpeakerOrder} from './common/order';
import {initPromotion} from './common/promotion';

window.$(() => {
    $(document).foundation();
    feedBlog();
    initJournal();
    partnersSwiper();
    clientsSwiper();
    certificateSwiper();
    footerSwiper();
    decisionsSwiper();
    gallerySwiper();
    initMagazine();
    initImgSwipe();
    initMasterClass();
    initSubscribe();
    initScrollTo();
    initSpeakerOrder();
    initPromotion();

    // Init lazyLoad
    // eslint-disable-next-line no-unused-vars,no-undef
    let lazyLoadInstance = new LazyLoad({elements_selector: '.lazy'});

    $('.fancybox').fancybox();

    $('.slick-slider').each((i, item) => {
        $(item).slick({
            slidesToShow: 2,
            lazyLoad: 'ondemand',
            infinite: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        slidesToShow: 2,
                        variableWidth: true,
                    },
                },
            ],
        });
    });

    // Initialise with options
    let banner = new Headhesive('.header-menu', {
        offset: '.orbit',
        offsetSide: 'top',
        classes: {
            clone: 'header--clone',
            stick: 'header--stick',
            unstick: 'header--unstick',
        },
    });
});
